import React from 'react'
import PropTypes from 'prop-types'

const ErrorMessage = ({message}) => {
  return <div>{message}</div>
}

ErrorMessage.propTypes = {
    message: PropTypes.string
}

ErrorMessage.defaultProps = {
    message: 'Error fetching data! Please try again later'
}


export default ErrorMessage
